module.exports = __webpack_public_path__ + "assets/media/lunch.356b726f.mp3";